<template>
  <div>
    <v-badge :value="quantity" overlap dot>
      <v-icon @click="openMessageBox(order)">mdi-email-outline</v-icon>
    </v-badge>

    <TheDialog icon="mdi-message" title="Mensagens" v-model="messageDialog" width="80%">
      <template>
        <TheOrderMessages :orderIdMarketplace="order.orderIdMarketplace" v-model="quantity" />
      </template>
    </TheDialog>
  </div>
</template>

<script>
import TheDialog from '@/components/TheDialog'
import TheOrderMessages from '@/components/TheOrderMessages'

export default {
  props: {
    order: Object,
  },
  components: {
    TheDialog,
    TheOrderMessages,
  },
  data: () => ({
    messageDialog: false,
    stage: 0,
    quantity: null,
  }),
  methods: {
    openMessageBox() {
      this.stage = 0
      this.messageDialog = true
    },
  },
}
</script>

<style></style>
